import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clusterStatusBadge',
  standalone: false,
})
export class ClusterStatusBadgePipe implements PipeTransform {
  transform(status: string): string {
    switch (status) {
      case 'RUNNING':
      case 'RESIZING':
        return 'state green';

      case 'PENDING':
      case 'RESTARTING':
        return 'state yellow';

      default:
        return 'state red';
    }
  }
}
